import React, { Component, useEffect, useState } from 'react';
import { render, unstable_renderSubtreeIntoContainer } from 'react-dom';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  plugins: {
    tooltip: {
      backgroundColor: 'rgb(255, 255, 255)',
      titleColor: '#000000',
      borderColor: '#eaeaea',
      borderWidth: '1',
      callbacks: {
        labelTextColor: function (context) {
          return '#333333';
        }
      }
    }
  }
};

const ValidateColor = (processValue) => {

  let status;
  if (processValue >= 90) {
    // Green
    status = 'rgba(60,196,128, 0.4)';
  } else if (processValue > 60 && processValue < 90) {
    // Yellow
    status = 'rgba(255,198,10, 0.4)';
  } else if (processValue <= 60) {
    // Red
    status = 'rgba(255,85,68, 0.4)';
  }

  return status;

}

const BarChart = ({ barchartData, name, isGeneric, options, showLabels, height: customHeight }) => {

  const [barChartData, SetBarChart] = useState();
  const [barUpdated, SetBarUpdated] = useState(true);
  useEffect(() => {

    let barChartInputData = [];
    if (!isGeneric) {
      if (barchartData.data !== null && barchartData.data !== undefined) {
        barchartData.data && barchartData.data.map((item, index) => {
          let barChartInputDataObject = {};
          Object.keys(item).map((key, index) => {
            barChartInputDataObject.label = key;
            barChartInputDataObject.value = item[key];
          });
          barChartInputData.push(barChartInputDataObject);
        });
      } else {
        barChartInputData = barchartData;
      }
    } else {
      barChartInputData = barchartData.data;
    }

    if (barChartInputData === null || barChartInputData === undefined) return false;

    let barChartArray = [], labels = [];
    barChartInputData.map((item, index) => {
      barChartArray.push(item.value);

      if (item.label === undefined || item.label === null || item.label === 'value' || item.label === '') {
        if (item.ts) {
          labels.push(moment(item.ts).format('MM/DD/YYYY'));
        } else if (item.name) {
          labels.push(item.name);
        } else {
          labels.push('');
        }
      } else {
        labels.push(item.label);
      }

    });

    SetBarUpdated(!barUpdated);
    SetBarChart({
      labels: labels,
      datasets: [
        {
          label: '',
          data: barChartArray,
          backgroundColor: [
            'rgb(53,135,184)'
          ],
          borderColor: [
            'rgb(53,135,184)'
          ],
          borderWidth: 1,
        },
      ],
    });

  }, []);

  return <div className='bar-chart-container' key={barUpdated}  >
    {barChartData && <Bar data={barChartData} height={customHeight} options={options} redraw />}
  </div>

};

export default BarChart;